/* Copyright (c) 2025 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { isValidDate } from "~/tools";

export const validateDate = (value: string | null): string | true => {
  if (isValidDate(value)) return true;

  return "Please use YYYY-MM-DD format (e.g., 2025-01-12)";
};

export const tenantOptions = [
  { value: "PD US", label: "PD US" },
  { value: "PD EU", label: "PD EU" },
];
